module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ExtraLightItalic-565e8654cd0a4bb6bf6b870f39edea7c.otf";